import React from "react";
import HomeMain from "./main";
import ProductOverview from "./productOverview";
import ZForHer from "./zForHer";
import HowItWorks from "./howItWorks";
import DownloadApp from "./downloadApp";
import Testimonials from "./testimonials";
import BlogPreview from "./blogPreview";
import FAQ from "./faq";
import CTA from "./cta";
import Footer from "../../components/footer";
import Audit from "./audit";
import Box from "@mui/material/Box";

const IndexHome = () => {
	return (
		<Box>
			<HomeMain />
			<ProductOverview />
			<ZForHer />
			<DownloadApp />
			<HowItWorks />
			<Testimonials />
			<BlogPreview />
			<FAQ />
			<Audit />
			<CTA />
			<Footer />
		</Box>
	);
};

export default IndexHome;
